import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { api } from "../lib/api";

/**
 * Public privacy policy page for a single business.
 * URL: /p/:bid/privacy
 * Auto-generated from the business's privacy_settings, never authenticated.
 */
export default function BusinessPrivacy() {
  const { bid } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/businesses/${bid}/privacy-public`)
      .then((r) => setData(r.data))
      .catch((e) => setErr(e.response?.status === 404 ? "Attività non trovata" : "Errore di caricamento"))
      .finally(() => setLoading(false));
  }, [bid]);

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-12" data-testid="business-privacy-page">
      <div className="mb-6 flex items-center gap-3 text-sm text-zinc-500 dark:text-zinc-400">
        <Link to={`/book/${bid}`} className="hover:text-zinc-900 dark:hover:text-zinc-100" data-testid="biz-privacy-back">← Torna alla pagina di prenotazione</Link>
      </div>

      {loading ? (
        <div className="text-sm text-zinc-500 dark:text-zinc-400">Caricamento…</div>
      ) : err ? (
        <div className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-2xl px-4 py-3 dark:text-rose-300 dark:bg-rose-950/40 dark:border-rose-800/50">{err}</div>
      ) : (
        <>
          {!data?.configured && (
            <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 mb-6 text-sm text-amber-900 dark:border-amber-800/50 dark:bg-amber-950/40 dark:text-amber-200" data-testid="biz-privacy-placeholder">
              ⚠️ <strong>{data?.business_name}</strong> non ha ancora pubblicato la propria informativa completa. Sotto trovi un riferimento provvisorio. Per qualunque domanda, contatta direttamente l'attività.
            </div>
          )}
          <article className="prose prose-zinc max-w-none prose-headings:font-display prose-headings:font-medium prose-h1:text-4xl prose-h2:text-2xl prose-h3:text-xl prose-a:text-blue-600 prose-table:text-sm">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{data?.content || ""}</ReactMarkdown>
          </article>
        </>
      )}
    </div>
  );
}
